import {
  RECORD_USERINFO,
  AUTO_USERINFO,
  OUT_LOGIN,

  CONFIG_INFO,
  LEVELINFO,
  UNREADCOUNT,
  NOTICELIST
  // UPDATE_BANKCARD
} from './mutation-types.js'
import { addCookie, deleteCookie } from '@/common/js/cookies'
// import { saveToLocal } from '@/common/js/store'

export default {
  // 登陆注册试玩记录用户信息
  [RECORD_USERINFO](state, info) {
    state.userInfo = info
    state.logined = true
    state.unread = info.unReadCount
    // saveToLocal('token', info['assess-token'])
    // saveToLocal('username', info.username)
    // saveToLocal('auth_status', info.auth_status)
    addCookie('isLogined', true, 120)
  },
  // 自动登陆
  [AUTO_USERINFO](state, info) {
    state.userInfo = info
    state.unread = info.unReadCount
    state.logined = true
  },
  // 退出登录
  [OUT_LOGIN](state) {
    state.userInfo = null
    state.logined = false
    deleteCookie('isLogined')
  },

  // 网站基本信息
  [CONFIG_INFO](state, info) {
    state.config_info = info
  },
  // 等级收件箱未读数等信息
  [LEVELINFO](state, info) {
    if (info) {
      state.levelInfo = info
      state.balance.data = {
        'bonus': info.bonus,
        'commission': info.commission,
        'handsel': info.handsel,
        'recharge': info.recharge
      }
      let balance = 0
      for (let i in state.balance.data) {
        balance += parseFloat(state.balance.data[i])
        balance = Math.round(balance * 1000) / 1000
      }
      state.balance.all = balance.toFixed(3)
    } else {
      state.levelInfo = info
      state.balance = {}
    }
  },
  // 更新未读条数
  [UNREADCOUNT](state, count) {
    state.unread = count
  },

  // 公告通知
  [NOTICELIST](state, info) {
    state.noticeList = info
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js